import { render } from "./BlockTimeSeriesChart.vue?vue&type=template&id=bb4bee90&scoped=true"
import script from "./BlockTimeSeriesChart.vue?vue&type=script&lang=js"
export * from "./BlockTimeSeriesChart.vue?vue&type=script&lang=js"

import "./BlockTimeSeriesChart.vue?vue&type=style&index=0&id=bb4bee90&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4bee90"],['__file',"resources/js/components/BlockTimeSeriesChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb4bee90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb4bee90', __exports__)) {
    api.reload('bb4bee90', __exports__)
  }
  
  module.hot.accept("./BlockTimeSeriesChart.vue?vue&type=template&id=bb4bee90&scoped=true", () => {
    api.rerender('bb4bee90', render)
  })

}


export default __exports__